class $f3d6c32b69e1737a$export$3ee77597cd288884 extends window.HTMLElement {
    onExecutionFinished(LogEntry) {
        if (LogEntry.timedOut) this.renderExecutionResult("action-timeout", "Timed out");
        else if (LogEntry.blocked) this.renderExecutionResult("action-blocked", "Blocked!");
        else if (LogEntry.exitCode !== 0) this.renderExecutionResult("action-nonzero-exit", "Exit code " + LogEntry.exitCode);
        else {
            this.ellapsed = Math.ceil(new Date(LogEntry.datetimeFinished) - new Date(LogEntry.datetimeStarted)) / 1000;
            this.renderExecutionResult("action-success", "Success!");
        }
    }
    renderExecutionResult(resultCssClass, temporaryStatusMessage) {
        this.updateDom(resultCssClass, "[" + temporaryStatusMessage + "]");
        this.onExecStatusChanged();
    }
    updateDom(resultCssClass, title) {
        if (resultCssClass == null) this.btn.className = "";
        else this.btn.classList.add(resultCssClass);
        this.domTitle.innerText = title;
    }
}


class $ddb9e1385d59ae64$var$ExecutionButton extends (0, $f3d6c32b69e1737a$export$3ee77597cd288884) {
    constructFromJson(json) {
        this.executionTrackingId = json;
        this.ellapsed = 0;
        this.appendChild(document.createElement("button"));
        this.isWaiting = true;
        this.setAttribute("id", "execution-" + json);
        this.btn = this.querySelector("button");
        this.btn.innerText = "Executing...";
        this.btn.onclick = ()=>{
            this.show();
        };
        this.domTitle = this.btn;
    }
    show() {
        window.executionDialog.reset();
        window.executionDialog.show();
        window.executionDialog.fetchExecutionResult(this.executionTrackingId);
    }
    onExecStatusChanged() {
        this.domTitle.innerText = this.ellapsed + "s";
        this.btn.title = this.ellapsed + " seconds";
    }
}
window.customElements.define("execution-button", $ddb9e1385d59ae64$var$ExecutionButton);


class $d27e19dd0fba4b85$var$ArgumentForm extends window.HTMLElement {
    setup(json, callback) {
        this.setAttribute("class", "action-arguments");
        this.constructTemplate();
        this.domTitle.innerText = json.title;
        this.domIcon.innerHTML = json.icon;
        this.createDomFormArguments(json.arguments);
        this.domBtnStart.onclick = ()=>{
            for (const arg of this.argInputs){
                if (!arg.validity.valid) return;
            }
            const argvs = this.getArgumentValues();
            callback(argvs);
            this.remove();
        };
        this.domBtnCancel.onclick = ()=>{
            this.remove();
        };
    }
    getArgumentValues() {
        const ret = [];
        for (const arg of this.argInputs)ret.push({
            name: arg.name,
            value: arg.value
        });
        return ret;
    }
    constructTemplate() {
        const tpl = document.getElementById("tplArgumentForm");
        const content = tpl.content.cloneNode(true);
        this.appendChild(content);
        this.domTitle = this.querySelector("h2");
        this.domIcon = this.querySelector("span.icon");
        this.domWrapper = this.querySelector(".wrapper");
        this.domArgs = this.querySelector(".arguments");
        this.domBtnStart = this.querySelector("[name=start]");
        this.domBtnCancel = this.querySelector("[name=cancel]");
    }
    createDomFormArguments(args) {
        this.argInputs = [];
        for (const arg of args){
            const domArgumentWrapper = document.createElement("p");
            domArgumentWrapper.classList.add("argument-wrapper");
            domArgumentWrapper.appendChild(this.createDomLabel(arg));
            domArgumentWrapper.appendChild(this.createDomSuggestions(arg));
            domArgumentWrapper.appendChild(this.createDomInput(arg));
            domArgumentWrapper.appendChild(this.createDomDescription(arg));
            this.domArgs.appendChild(domArgumentWrapper);
        }
    }
    createDomLabel(arg) {
        const domLbl = document.createElement("label");
        domLbl.innerText = arg.title + ":";
        domLbl.setAttribute("for", arg.name);
        return domLbl;
    }
    createDomSuggestions(arg) {
        if (typeof arg.suggestions !== "object" || arg.suggestions.length === 0) return document.createElement("span");
        const ret = document.createElement("datalist");
        ret.setAttribute("id", arg.name + "-choices");
        for (const suggestion of Object.keys(arg.suggestions)){
            const opt = document.createElement("option");
            opt.setAttribute("value", suggestion);
            if (typeof arg.suggestions[suggestion] !== "undefined" && arg.suggestions[suggestion].length > 0) opt.innerText = arg.suggestions[suggestion];
            ret.appendChild(opt);
        }
        return ret;
    }
    createDomInput(arg) {
        let domEl = null;
        if (arg.choices.length > 0) {
            domEl = document.createElement("select");
            // select/choice elements don't get an onchange/validation because theoretically
            // the user should only select from a dropdown of valid options. The choices are
            // riggeriously checked on StartAction anyway. ValidateArgumentType is only
            // meant for showing simple warnings in the UI before running.
            for (const choice of arg.choices)domEl.appendChild(this.createSelectOption(choice));
        } else if (arg.type === "confirmation") {
            this.domBtnStart.disabled = true;
            domEl = document.createElement("input");
            domEl.setAttribute("type", "checkbox");
            domEl.onchange = ()=>{
                this.domBtnStart.disabled = false;
                domEl.disabled = true;
            };
        } else if (arg.type === "datetime") {
            domEl = document.createElement("input");
            domEl.setAttribute("type", "datetime-local");
            domEl.setAttribute("step", "1");
        } else {
            domEl = document.createElement("input");
            if (arg.type.startsWith("regex:")) domEl.setAttribute("pattern", arg.type.replace("regex:", ""));
            domEl.onchange = ()=>{
                const validateArgumentTypeArgs = {
                    value: domEl.value,
                    type: arg.type
                };
                window.fetch(window.restBaseUrl + "ValidateArgumentType", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(validateArgumentTypeArgs)
                }).then((res)=>{
                    if (res.ok) return res.json();
                    else throw new Error(res.statusText);
                }).then((json)=>{
                    if (json.valid) domEl.setCustomValidity("");
                    else domEl.setCustomValidity(json.description);
                });
            };
        }
        domEl.name = arg.name;
        domEl.value = arg.defaultValue;
        if (typeof arg.suggestions === "object" && Object.keys(arg.suggestions).length > 0) domEl.setAttribute("list", arg.name + "-choices");
        this.argInputs.push(domEl);
        return domEl;
    }
    createDomDescription(arg) {
        const domArgumentDescription = document.createElement("span");
        domArgumentDescription.classList.add("argument-description");
        domArgumentDescription.innerText = arg.description;
        return domArgumentDescription;
    }
    createSelectOption(choice) {
        const domEl = document.createElement("option");
        domEl.setAttribute("value", choice.value);
        domEl.innerText = choice.title;
        return domEl;
    }
}
window.customElements.define("argument-form", $d27e19dd0fba4b85$var$ArgumentForm);



class $8bf6d56790719e7d$var$ActionButton extends (0, $f3d6c32b69e1737a$export$3ee77597cd288884) {
    constructDomFromTemplate() {
        const tpl = document.getElementById("tplActionButton");
        const content = tpl.content.cloneNode(true);
        /*
     * FIXME: Should probably be using a shadowdom here, but seem to
     * get an error when combined with custom elements.
     */ this.appendChild(content);
        this.btn = this.querySelector("button");
        this.domTitle = this.btn.querySelector(".title");
        this.domIcon = this.btn.querySelector(".icon");
    }
    constructFromJson(json) {
        this.updateIterationTimestamp = 0;
        this.constructDomFromTemplate();
        // Class attributes
        this.updateFromJson(json);
        this.actionId = json.id;
        // DOM Attributes
        this.setAttribute("role", "none");
        this.setAttribute("id", "actionButton-" + this.actionId);
        this.btn.setAttribute("id", "actionButtonInner-" + this.actionId);
        this.btn.title = json.title;
        this.btn.onclick = ()=>{
            if (json.arguments.length > 0) {
                for (const oldArgumentForm of document.querySelectorAll("argument-form"))oldArgumentForm.remove();
                const frm = document.createElement("argument-form");
                frm.setup(json, (args)=>{
                    this.startAction(args);
                });
                document.body.appendChild(frm);
                frm.querySelector("dialog").showModal();
            } else this.startAction();
        };
        this.popupOnStart = json.popupOnStart;
        this.updateFromJson(json);
        this.domTitle.innerText = this.btn.title;
        this.domIcon.innerHTML = this.unicodeIcon;
    }
    updateFromJson(json) {
        // Fields that should not be updated
        //
        // title - as the callback URL relies on it
        if (json.icon === "") this.unicodeIcon = "&#x1f4a9";
        else this.unicodeIcon = unescape(json.icon);
    }
    onExecStatusChanged() {
        this.btn.disabled = false;
        setTimeout(()=>{
            this.updateDom(null, this.btn.title);
        }, 2000);
    }
    getUniqueId() {
        if (window.isSecureContext) return window.crypto.randomUUID();
        else return Date.now().toString();
    }
    startAction(actionArgs) {
        this.btn.classList = [] // Removes old animation classes
        ;
        if (actionArgs === undefined) actionArgs = [];
        // UUIDs are create client side, so that we can setup a "execution-button"
        // to track the execution before we send the request to the server.
        const startActionArgs = {
            actionId: this.actionId,
            arguments: actionArgs,
            uniqueTrackingId: this.getUniqueId()
        };
        this.onActionStarted(startActionArgs.uniqueTrackingId);
        window.fetch(window.restBaseUrl + "StartAction", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(startActionArgs)
        }).then((res)=>{
            if (res.ok) return res.json();
            else throw new Error(res.statusText);
        }).then((json)=>{
        // The button used to wait for the action to finish, but now it is fire & forget
        }).catch((err)=>{
            throw err // We used to flash buttons red, but now hand to the global error handler
            ;
        });
    }
    onActionStarted(executionTrackingId) {
        if (this.popupOnStart === "execution-button") {
            const btnExecution = document.createElement("execution-button");
            btnExecution.constructFromJson(executionTrackingId);
            this.querySelector(".action-button-footer").hidden = false;
            this.querySelector(".action-button-footer").style.display = "flex";
            this.querySelector(".action-button-footer").prepend(btnExecution);
            return;
        }
        if (this.popupOnStart.includes("execution-dialog")) {
            window.executionDialog.reset();
            if (this.popupOnStart === "execution-dialog-stdout-only") window.executionDialog.hideEverythingApartFromOutput();
            window.executionDialog.show(this);
        }
        this.btn.disabled = true;
    }
}
window.customElements.define("action-button", $8bf6d56790719e7d$var$ActionButton);


// This ExecutionDialog is NOT a custom HTML element, but rather just picks up
// the <dialog /> element out of index.html and just re-uses that - as only
// one dialog can be shown at a time.
class $8ffdc0a6be00c5fb$export$ea5914f61ebfa0b9 {
    constructor(){
        this.dlg = document.querySelector("dialog#execution-results-popup");
        this.domIcon = document.getElementById("execution-dialog-icon");
        this.domTitle = document.getElementById("execution-dialog-title");
        this.domStdout = document.getElementById("execution-dialog-stdout");
        this.domStderr = document.getElementById("execution-dialog-stderr");
        this.domStdoutToggleBig = document.getElementById("execution-dialog-toggle-size");
        this.domStdoutToggleBig.onclick = ()=>{
            this.toggleSize();
        };
        this.domDatetimeStarted = document.getElementById("execution-dialog-datetime-started");
        this.domDatetimeFinished = document.getElementById("execution-dialog-datetime-finished");
        this.domExitCode = document.getElementById("execution-dialog-exit-code");
        this.domStatus = document.getElementById("execution-dialog-status");
        this.domExecutionBasics = document.getElementById("execution-dialog-basics");
        this.domExecutionDetails = document.getElementById("execution-dialog-details");
        this.domExecutionOutput = document.getElementById("execution-dialog-output");
    }
    toggleSize() {
        if (this.dlg.classList.contains("big")) {
            this.dlg.classList.remove("big");
            this.domStdout.parentElement.open = false;
        } else {
            this.dlg.classList.add("big");
            this.domStdout.parentElement.open = true;
        }
    }
    reset() {
        this.executionSeconds = 0;
        this.dlg.classList.remove("big");
        this.dlg.style.maxWidth = "calc(100vw - 2em)";
        this.dlg.style.width = "";
        this.dlg.style.height = "";
        this.dlg.style.border = "";
        this.domStdoutToggleBig.hidden = false;
        this.domIcon.innerText = "";
        this.domTitle.innerText = "Waiting for result... ";
        this.domExitCode.innerText = "?";
        this.domStatus.className = "";
        this.domDatetimeStarted.innerText = "";
        this.domDatetimeFinished.innerText = "";
        this.domStdout.innerText = "";
        this.domStderr.innerText = "";
        this.hideDetailsOnResult = false;
        this.domExecutionBasics.hidden = false;
        this.domExecutionDetails.hidden = true;
        this.domStdout.parentElement.open = false;
        this.domExecutionOutput.hidden = true;
    }
    show(actionButton) {
        if (typeof actionButton !== "undefined" && actionButton != null) this.domIcon.innerText = actionButton.domIcon.innerText;
        clearInterval(window.executionDialogTicker);
        this.executionSeconds = 0;
        this.executionTick();
        window.executionDialogTicker = setInterval(()=>{
            this.executionTick();
        }, 1000);
        this.dlg.showModal();
    }
    executionTick() {
        this.executionSeconds++;
        this.domDatetimeStarted.innerText = this.executionSeconds + " seconds ago";
    }
    hideEverythingApartFromOutput() {
        this.hideDetailsOnResult = true;
        this.domExecutionBasics.hidden = true;
    }
    fetchExecutionResult(uuid) {
        this.executionTrackingId = uuid;
        const executionStatusArgs = {
            executionTrackingId: this.executionTrackingId
        };
        window.fetch(window.restBaseUrl + "ExecutionStatus", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(executionStatusArgs)
        }).then((res)=>{
            if (res.ok) return res.json();
            else throw new Error(res.statusText);
        }).then((json)=>{
            this.renderExecutionResult(json);
        }).catch((err)=>{
            this.renderError(err);
        });
    }
    renderExecutionResult(res) {
        clearInterval(window.executionDialogTicker);
        this.domExecutionOutput.hidden = false;
        if (!this.hideDetailsOnResult) this.domExecutionDetails.hidden = false;
        else this.domStdout.parentElement.open = true;
        this.executionTrackingId = res.logEntry.executionTrackingId;
        if (res.logEntry.executionFinished) {
            this.domStatus.innerText = "Completed";
            this.domStatus.classList.add("action-success");
            this.domDatetimeFinished.innerText = res.logEntry.datetimeFinished;
            if (res.logEntry.timedOut) {
                this.domExitCode.innerText = "Timed out";
                this.domStatus.classList.add("action-timeout");
            } else if (res.logEntry.blocked) {
                this.domStatus.innerText = "Blocked";
                this.domStatus.classList.add("action-blocked");
            } else if (res.logEntry.exitCode !== 0) {
                this.domStatus.innerText = "Non-Zero Exit";
                this.domStatus.classList.add("action-nonzero-exit");
            } else this.domExitCode.innerText = res.logEntry.exitCode;
        } else {
            this.domDatetimeFinished.innerText = "Still running...";
            this.domExitCode.innerText = "Still running...";
            this.domStatus.innerText = "Still running...";
        }
        this.domIcon.innerHTML = res.logEntry.actionIcon;
        this.domTitle.innerText = res.logEntry.actionTitle;
        this.domStdout.innerText = res.logEntry.stdout;
        this.domStdout.innerText = res.logEntry.stdout;
        if (res.logEntry.stderr === "(empty)") {
            this.domStderr.parentElement.style.display = "none";
            this.domStderr.innerText = res.logEntry.stderr;
        } else {
            this.domStderr.parentElement.style.display = "block";
            this.domStderr.innerText = res.logEntry.stderr;
        }
        this.domDatetimeStarted.innerText = res.logEntry.datetimeStarted;
    }
    renderError(err) {
        this.dlg.querySelector("pre").innerText = JSON.stringify(err);
    }
}


function $b1f2c0883b9e7182$export$d607d4bfd1043607() {
    window.changeDirectory = $b1f2c0883b9e7182$var$changeDirectory;
    window.showSection = $b1f2c0883b9e7182$var$showSection;
    window.executionDialog = new (0, $8ffdc0a6be00c5fb$export$ea5914f61ebfa0b9)();
    window.logEntries = {};
    window.addEventListener("ExecutionFinished", $b1f2c0883b9e7182$var$onExecutionFinished);
}
function $b1f2c0883b9e7182$export$d2fc876287b4b64c(json) {
    $b1f2c0883b9e7182$var$marshalActionsJsonToHtml(json);
    $b1f2c0883b9e7182$var$marshalDashboardStructureToHtml(json);
    $b1f2c0883b9e7182$var$changeDirectory(null);
}
function $b1f2c0883b9e7182$var$marshalActionsJsonToHtml(json) {
    const currentIterationTimestamp = Date.now();
    window.actionButtons = {};
    for (const jsonButton of json.actions){
        let htmlButton = window.actionButtons[jsonButton.id];
        if (typeof htmlButton === "undefined") {
            htmlButton = document.createElement("action-button");
            htmlButton.constructFromJson(jsonButton);
            window.actionButtons[jsonButton.title] = htmlButton;
        }
        htmlButton.updateFromJson(jsonButton);
        htmlButton.updateIterationTimestamp = currentIterationTimestamp;
    }
    // Remove existing, but stale buttons (that were not updated in this round)
    for (const existingButton of document.querySelectorAll("action-button"))if (existingButton.updateIterationTimestamp !== currentIterationTimestamp) existingButton.remove();
}
function $b1f2c0883b9e7182$var$onExecutionFinished(evt) {
    const logEntry = evt.payload;
    const actionButton = window.actionButtons[logEntry.actionTitle];
    if (actionButton === undefined) return;
    switch(actionButton.popupOnStart){
        case "execution-button":
            document.querySelector("execution-button#execution-" + logEntry.executionTrackingId).onExecutionFinished(logEntry);
            break;
        case "execution-dialog-stdout-only":
        case "execution-dialog":
            actionButton.onExecutionFinished(logEntry);
            // We don't need to fetch the logEntry for the dialog because we already
            // have it, so we open the dialog and it will get updated below.
            window.executionDialog.show();
            window.executionDialog.executionUuid = logEntry.uuid;
            break;
        default:
            actionButton.onExecutionFinished(logEntry);
            break;
    }
    $b1f2c0883b9e7182$export$1db54924ed9bdd93({
        logs: [
            logEntry
        ]
    });
    // If the current execution dialog is open, update that too
    if (window.executionDialog.dlg.open && window.executionDialog.executionUuid === logEntry.uuid) window.executionDialog.renderExecutionResult({
        logEntry: logEntry
    });
}
function $b1f2c0883b9e7182$var$showSection(title) {
    for (const section of document.querySelectorAll("section"))if (section.title === title) section.style.display = "block";
    else section.style.display = "none";
    for (const otherName of [
        "Actions",
        "Logs"
    ]){
        document.getElementById("show" + otherName).classList.remove("activeSection");
        document.getElementById("content" + otherName).hidden = true;
    }
    //  document.getElementById('show' + name).classList.add('activeSection')
    // document.getElementById('content' + name).hidden = false
    document.getElementById("hide-sidebar-checkbox").checked = true;
    $b1f2c0883b9e7182$var$changeDirectory(null);
}
function $b1f2c0883b9e7182$export$d49481e1530c241e(style) {
    const nav = document.querySelector("nav");
    if (style === "sidebar") {
        nav.classList += "sidebar";
        document.body.classList += "has-sidebar";
    } else {
        nav.classList += "topbar";
        document.body.classList += "has-topbar";
    }
    nav.hidden = false;
    document.getElementById("showActions").onclick = ()=>{
        $b1f2c0883b9e7182$var$showSection("Actions");
    };
    document.getElementById("showLogs").onclick = ()=>{
        $b1f2c0883b9e7182$var$showSection("Logs");
    };
}
function $b1f2c0883b9e7182$var$marshalDashboardStructureToHtml(json) {
    const nav = document.getElementById("navigation-links");
    for (const dashboard of json.dashboards){
        const oldsection = document.querySelector('section[title="' + dashboard.title + '"]');
        if (oldsection != null) oldsection.remove();
        const section = document.createElement("section");
        section.title = dashboard.title;
        const def = $b1f2c0883b9e7182$var$createFieldset("default", section);
        section.appendChild(def);
        document.getElementsByTagName("main")[0].appendChild(section);
        $b1f2c0883b9e7182$var$marshalContainerContents(dashboard, section, def, dashboard.title);
        const oldLi = nav.querySelector('li[title="' + dashboard.title + '"]');
        if (oldLi != null) oldLi.remove();
        const navigationA = document.createElement("a");
        navigationA.title = dashboard.title;
        navigationA.innerText = dashboard.title;
        navigationA.onclick = ()=>{
            $b1f2c0883b9e7182$var$showSection(dashboard.title);
        };
        const navigationLi = document.createElement("li");
        navigationLi.appendChild(navigationA);
        navigationLi.title = dashboard.title;
        document.getElementById("navigation-links").appendChild(navigationLi);
    }
    const rootGroup = document.querySelector("#root-group");
    for (const btn of Object.values(window.actionButtons))if (btn.parentElement === null) rootGroup.appendChild(btn);
    if (rootGroup.querySelectorAll("action-button").length === 0 && json.dashboards.length > 0) {
        nav.querySelector('li[title="Actions"]').style.display = "none";
        $b1f2c0883b9e7182$var$showSection(json.dashboards[0].title);
    } else $b1f2c0883b9e7182$var$showSection("Actions");
}
function $b1f2c0883b9e7182$var$marshalLink(item, fieldset) {
    let btn = window.actionButtons[item.title];
    if (typeof btn === "undefined") {
        btn = document.createElement("button");
        btn.innerText = "Action not found: " + item.title;
        btn.classList.add("error");
    }
    fieldset.appendChild(btn);
}
function $b1f2c0883b9e7182$var$marshalMreOutput(dashboardComponent, fieldset) {
    const pre = document.createElement("pre");
    pre.classList.add("mre-output");
    pre.innerHTML = "Waiting...";
    const executionStatus = {
        actionId: dashboardComponent.title
    };
    window.fetch(window.restBaseUrl + "ExecutionStatus", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(executionStatus)
    }).then((res)=>{
        if (res.ok) return res.json();
        else {
            pre.innerHTML = "error";
            throw new Error(res.statusText);
        }
    }).then((json)=>{
        updateMre(pre, json.logEntry);
    });
    const updateMre = (pre, json)=>{
        pre.innerHTML = json.stdout;
    };
    window.addEventListener("ExecutionFinished", (e)=>{
        // The dashboard component "title" field is used for lots of things
        // and in this context for MreOutput it's just to refer an an actionId.
        //
        // So this is not a typo.
        if (e.payload.actionId === dashboardComponent.title) updateMre(pre, e.payload);
    });
    fieldset.appendChild(pre);
}
function $b1f2c0883b9e7182$var$marshalContainerContents(json, section, fieldset, parentDashboard) {
    for (const item of json.contents)switch(item.type){
        case "fieldset":
            $b1f2c0883b9e7182$var$marshalFieldset(item, section, parentDashboard);
            break;
        case "directory":
            $b1f2c0883b9e7182$var$marshalDirectoryButton(item, fieldset);
            $b1f2c0883b9e7182$var$marshalDirectory(item, section);
            break;
        case "display":
            $b1f2c0883b9e7182$var$marshalDisplay(item, fieldset);
            break;
        case "stdout-most-recent-execution":
            $b1f2c0883b9e7182$var$marshalMreOutput(item, fieldset);
            break;
        case "link":
            $b1f2c0883b9e7182$var$marshalLink(item, fieldset);
            break;
        default:
    }
}
function $b1f2c0883b9e7182$var$createFieldset(title, parentDashboard) {
    const legend = document.createElement("legend");
    legend.innerText = title;
    const fs = document.createElement("fieldset");
    fs.title = title;
    fs.appendChild(legend);
    if (typeof parentDashboard === "undefined") fs.setAttribute("parent-dashboard", "");
    else fs.setAttribute("parent-dashboard", parentDashboard);
    return fs;
}
function $b1f2c0883b9e7182$var$marshalFieldset(item, section, parentDashboard) {
    const fs = $b1f2c0883b9e7182$var$createFieldset(item.title, parentDashboard);
    $b1f2c0883b9e7182$var$marshalContainerContents(item, section, fs);
    section.appendChild(fs);
}
function $b1f2c0883b9e7182$var$changeDirectory(selected) {
    if (selected === "") selected = null;
    if (selected === null) window.directoryNavigation = [];
    else if (selected === "..") {
        window.directoryNavigation.pop();
        if (window.directoryNavigation.length > 0) selected = window.directoryNavigation[window.directoryNavigation.length - 1];
        else selected = null;
    } else {
        // If the selected item is already in the nav list, pop elements until we get
        // "back" to the existing nav item
        while(window.directoryNavigation.includes(selected))window.directoryNavigation.pop();
        window.directoryNavigation.push(selected);
    }
    for (const fieldset of document.querySelectorAll("fieldset")){
        if (selected === null) {
            if ((fieldset.id === "root-group" || fieldset.getAttribute("parent-dashboard") !== "") && fieldset.children.length > 1) fieldset.style.display = "grid";
            else fieldset.style.display = "none";
        } else if (fieldset.title === selected) fieldset.style.display = "grid";
        else fieldset.style.display = "none";
    }
    const title = document.querySelector("h1");
    title.innerHTML = "";
    const rootLink = $b1f2c0883b9e7182$var$createDirectoryBreadcrumb(window.pageTitle, null);
    title.appendChild(rootLink);
    for (const dir of window.directoryNavigation){
        const sep = document.createElement("span");
        sep.innerHTML = " &raquo; ";
        title.append(sep);
        if (dir === selected) title.append(selected);
        else title.appendChild($b1f2c0883b9e7182$var$createDirectoryBreadcrumb(dir));
    }
    document.title = title.innerText;
    if (selected === null) {
        window.location.hash = null;
        window.history.pushState({
            dir: null
        }, null, "#");
    } else {
        window.location.hash = selected;
        window.history.pushState({
            dir: selected
        }, null, "#" + selected);
    }
}
function $b1f2c0883b9e7182$var$createDirectoryBreadcrumb(title, link) {
    const a = document.createElement("a");
    a.innerText = title;
    a.title = title;
    if (typeof link === "undefined") link = title;
    if (link === null) a.href = "#";
    else a.href = "#" + link;
    a.onclick = ()=>{
        $b1f2c0883b9e7182$var$changeDirectory(link);
    };
    return a;
}
function $b1f2c0883b9e7182$var$marshalDisplay(item, fieldset) {
    const display = document.createElement("div");
    display.innerHTML = item.title;
    fieldset.appendChild(display);
}
function $b1f2c0883b9e7182$var$marshalDirectoryButton(item, fieldset) {
    const directoryButton = document.createElement("button");
    directoryButton.innerHTML = '<span class = "icon">&#128193;</span> ' + item.title;
    directoryButton.onclick = ()=>{
        $b1f2c0883b9e7182$var$changeDirectory(item.title);
    };
    fieldset.appendChild(directoryButton);
}
function $b1f2c0883b9e7182$var$marshalDirectory(item, section) {
    const fs = $b1f2c0883b9e7182$var$createFieldset(item.title);
    fs.style.display = "none";
    const directoryBackButton = document.createElement("button");
    directoryBackButton.innerHTML = "&laquo;";
    directoryBackButton.title = "Go back one directory";
    directoryBackButton.onclick = ()=>{
        $b1f2c0883b9e7182$var$changeDirectory("..");
    };
    fs.appendChild(directoryBackButton);
    $b1f2c0883b9e7182$var$marshalContainerContents(item, section, fs);
    section.appendChild(fs);
}
function $b1f2c0883b9e7182$export$1db54924ed9bdd93(json) {
    for (const logEntry of json.logs){
        const existing = window.logEntries[logEntry.executionTrackingId];
        if (existing !== undefined) continue;
        window.logEntries[logEntry.executionTrackingId] = logEntry;
        const tpl = document.getElementById("tplLogRow");
        const row = tpl.content.querySelector("tr").cloneNode(true);
        if (logEntry.stdout.length === 0) logEntry.stdout = "(empty)";
        if (logEntry.stderr.length === 0) logEntry.stderr = "(empty)";
        let logTableExitCode = logEntry.exitCode;
        if (logEntry.exitCode === 0) logTableExitCode = "OK";
        if (logEntry.timedOut) logTableExitCode += " (timed out)";
        row.querySelector(".timestamp").innerText = logEntry.datetimeStarted;
        row.querySelector(".content").innerText = logEntry.actionTitle;
        row.querySelector(".icon").innerHTML = logEntry.actionIcon;
        row.querySelector("pre.stdout").innerText = logEntry.stdout;
        row.querySelector("pre.stderr").innerText = logEntry.stderr;
        row.querySelector(".exit-code").innerText = logTableExitCode;
        row.setAttribute("title", logEntry.actionTitle);
        row.querySelector(".content").onclick = ()=>{
            window.executionDialog.reset();
            window.executionDialog.show();
            window.executionDialog.renderExecutionResult({
                logEntry: window.logEntries[logEntry.executionTrackingId]
            });
        };
        for (const tag of logEntry.tags){
            const domTag = document.createElement("span");
            domTag.classList.add("tag");
            domTag.innerText = tag;
            row.querySelector(".tags").append(domTag);
        }
        document.querySelector("#logTableBody").prepend(row);
    }
}
window.addEventListener("popstate", (e)=>{
    e.preventDefault();
    if (e.state != null && typeof e.state.dir !== "undefined") $b1f2c0883b9e7182$var$changeDirectory(e.state.dir);
});


window.ws = null;
function $59ca2b1ce7115640$export$ec53a98b4e5fa5cd() {
    if (window.ws === null || window.ws.readyState === 3) $59ca2b1ce7115640$var$reconnectWebsocket();
}
function $59ca2b1ce7115640$var$reconnectWebsocket() {
    window.websocketAvailable = false;
    let proto = "ws:";
    if (window.location.protocol === "https:") proto = "wss:";
    const websocketConnectionUrl = proto + window.location.host + "/websocket";
    const ws = window.ws = new WebSocket(websocketConnectionUrl);
    ws.addEventListener("open", $59ca2b1ce7115640$var$websocketOnOpen);
    ws.addEventListener("message", $59ca2b1ce7115640$var$websocketOnMessage);
    ws.addEventListener("error", $59ca2b1ce7115640$var$websocketOnError);
    ws.addEventListener("close", $59ca2b1ce7115640$var$websocketOnClose);
}
function $59ca2b1ce7115640$var$websocketOnOpen(evt) {
    window.websocketAvailable = true;
    window.ws.send("monitor");
    window.refreshLoop();
}
function $59ca2b1ce7115640$var$websocketOnMessage(msg) {
    // FIXME check msg status is OK
    const j = JSON.parse(msg.data);
    const e = new Event(j.type);
    e.payload = j.payload;
    switch(j.type){
        case "ExecutionFinished":
            window.dispatchEvent(e);
            break;
        default:
            window.showBigError("Unknown message type from server: " + j.type);
    }
}
function $59ca2b1ce7115640$var$websocketOnError(err) {
    window.websocketAvailable = false;
    window.refreshLoop();
    console.error(err);
}
function $59ca2b1ce7115640$var$websocketOnClose() {
    window.websocketAvailable = false;
}


"use strict";
function $efd3ba4ec2608b1d$var$searchLogs(e) {
    document.getElementById("searchLogsClear").disabled = false;
    const searchText = e.target.value.toLowerCase();
    for (const row of document.querySelectorAll("tr.log-row")){
        const actionTitle = row.getAttribute("title").toLowerCase();
        row.hidden = !actionTitle.includes(searchText);
    }
}
function $efd3ba4ec2608b1d$var$searchLogsClear() {
    for (const row of document.querySelectorAll("tr.log-row"))row.hidden = false;
    document.getElementById("searchLogsClear").disabled = true;
    document.getElementById("logSearchBox").value = "";
}
function $efd3ba4ec2608b1d$var$setupLogSearchBox() {
    document.getElementById("logSearchBox").oninput = $efd3ba4ec2608b1d$var$searchLogs;
    document.getElementById("searchLogsClear").onclick = $efd3ba4ec2608b1d$var$searchLogsClear;
}
function $efd3ba4ec2608b1d$var$refreshLoop() {
    if (window.websocketAvailable) ;
    else if (window.restAvailable) {
        // Fallback to rest, but try to reconnect the websocket anyway.
        $efd3ba4ec2608b1d$var$fetchGetDashboardComponents();
        $efd3ba4ec2608b1d$var$fetchGetLogs();
        (0, $59ca2b1ce7115640$export$ec53a98b4e5fa5cd)();
    } else // Still try to fetch the dashboard, if successfull window.restAvailable = true
    $efd3ba4ec2608b1d$var$fetchGetDashboardComponents();
    $efd3ba4ec2608b1d$var$refreshServerConnectionLabel();
}
function $efd3ba4ec2608b1d$var$refreshServerConnectionLabel() {
    if (window.restAvailable) document.querySelector("#serverConnectionRest").classList.remove("error");
    else document.querySelector("#serverConnectionRest").classList.add("error");
    if (window.websocketAvailable) document.querySelector("#serverConnectionWebSocket").classList.remove("error");
    else document.querySelector("#serverConnectionWebSocket").classList.add("error");
}
function $efd3ba4ec2608b1d$var$fetchGetDashboardComponents() {
    window.fetch(window.restBaseUrl + "GetDashboardComponents", {
        cors: "cors"
    }).then((res)=>{
        return res.json();
    }).then((res)=>{
        if (!window.restAvailable) window.clearBigErrors("fetch-buttons");
        window.restAvailable = true;
        (0, $b1f2c0883b9e7182$export$d2fc876287b4b64c)(res);
        $efd3ba4ec2608b1d$var$refreshServerConnectionLabel() // in-case it changed, update the label quicker
        ;
    }).catch((err)=>{
        window.restAvailable = false;
        window.showBigError("fetch-buttons", "getting buttons", err, "blat");
    });
}
function $efd3ba4ec2608b1d$var$fetchGetLogs() {
    window.fetch(window.restBaseUrl + "GetLogs", {
        cors: "cors"
    }).then((res)=>{
        return res.json();
    }).then((res)=>{
        (0, $b1f2c0883b9e7182$export$1db54924ed9bdd93)(res);
    }).catch((err)=>{
        window.showBigError("fetch-buttons", "getting buttons", err, "blat");
    });
}
function $efd3ba4ec2608b1d$var$processWebuiSettingsJson(settings) {
    window.restBaseUrl = settings.Rest;
    if (settings.ThemeName) {
        const themeCss = document.createElement("link");
        themeCss.setAttribute("rel", "stylesheet");
        themeCss.setAttribute("type", "text/css");
        themeCss.setAttribute("href", "/themes/" + settings.ThemeName + "/theme.css");
        document.head.appendChild(themeCss);
    }
    document.querySelector("#currentVersion").innerText = settings.CurrentVersion;
    if (settings.ShowNewVersions && settings.AvailableVersion !== "none") {
        document.querySelector("#available-version").innerText = "New Version Available: " + settings.AvailableVersion;
        document.querySelector("#available-version").hidden = false;
    }
    document.querySelector("#perma-widget").hidden = !settings.ShowNavigation;
    document.querySelector('footer[title="footer"]').hidden = !settings.ShowFooter;
    window.pageTitle = "OliveTin";
    if (settings.PageTitle) {
        window.pageTitle = settings.PageTitle;
        document.title = window.pageTitle;
        const titleElem = document.querySelector("#page-title");
        if (titleElem) titleElem.innerText = window.pageTitle;
    }
}
function $efd3ba4ec2608b1d$var$main() {
    (0, $b1f2c0883b9e7182$export$d607d4bfd1043607)();
    $efd3ba4ec2608b1d$var$setupLogSearchBox();
    (0, $b1f2c0883b9e7182$export$d49481e1530c241e)("sidebar");
    window.fetch("webUiSettings.json").then((res)=>{
        return res.json();
    }).then((res)=>{
        $efd3ba4ec2608b1d$var$processWebuiSettingsJson(res);
        window.restAvailable = true;
        window.refreshLoop = $efd3ba4ec2608b1d$var$refreshLoop;
        window.refreshLoop();
        setInterval($efd3ba4ec2608b1d$var$refreshLoop, 3000);
    }).catch((err)=>{
        window.showBigError("fetch-webui-settings", "getting webui settings", err);
    });
}
$efd3ba4ec2608b1d$var$main() // call self
;


//# sourceMappingURL=index.7016963a.js.map
